import React, { useState } from 'react';
import './Guide.css';
import { CreditCard, Zap, Smartphone, PhoneCall, ChevronDown, AlertTriangle } from 'react-feather';

export default function Guide() {
  const [activeTab, setActiveTab] = useState(null);

  const toggleTab = (index) => {
    if (activeTab === index) {
      setActiveTab(null);
    } else {
      setActiveTab(index);
    }
  };

  const guides = [
    {
      title: 'How to Deposit',
      icon: <CreditCard className="guide-icon" size={24} />,
      content: (
        <div className="guide-content-inner">
          <p>Adding funds to your account is quick and secure. Follow these steps:</p>
          <ol>
            <li>Navigate to the <strong>Add Funds</strong> page from the sidebar menu.</li>
            <li>Select your preferred payment method from the available options.</li>
            <li>Enter the amount you wish to deposit.</li>
            <li>Click on <strong>Pay</strong> and follow the instructions on the payment gateway.</li>
            <li>Once the payment is successful, your balance will be updated automatically!</li>
          </ol>
          <div style={{
            marginTop: 16,
            padding: 16,
            backgroundColor: 'rgba(239, 68, 68, 0.05)',
            border: '1px solid rgba(239, 68, 68, 0.3)',
            borderRadius: 8,
            display: 'flex',
            gap: 12
          }}>
            <AlertTriangle size={24} color="#ef4444" style={{ flexShrink: 0 }} />
            <div>
              <strong style={{ color: '#ef4444', display: 'block', marginBottom: 4 }}>Important Crypto Warning</strong>
              <p style={{ margin: 0, fontSize: '0.95rem' }}>
                If you choose to deposit via <strong>Crypto</strong>, you <strong>MUST</strong> ensure you send your funds using the exact <strong>Network (e.g., TRC20, BEP20, ERC20)</strong> specified on the checkout page. Sending crypto on the wrong network will result in <strong>permanent loss of funds</strong>.
              </p>
            </div>
          </div>
        </div>
      )
    },
    {
      title: 'How to Boost',
      icon: <Zap className="guide-icon" size={24} />,
      content: (
        <div className="guide-content-inner">
          <p>Ready to boost your social media presence? Here is how to place a new order:</p>
          <ol>
            <li>Go to the <strong>New Order</strong> page from the sidebar.</li>
            <li>Select a category (e.g., Instagram Followers, YouTube Views) that fits your needs.</li>
            <li>Choose a specific service from the dropdown menu. Pay attention to the description for details on start time and speed.</li>
            <li>Enter the link/URL where you want the boost to be delivered.</li>
            <li>Input the quantity you want to order. The price will be calculated automatically.</li>
            <li>Click <strong>Submit</strong> to place your order. You can track its progress in the <strong>My Orders</strong> section.</li>
          </ol>
        </div>
      )
    },
    {
      title: 'How to Buy a Number for SMS Verification',
      icon: <Smartphone className="guide-icon" size={24} />,
      content: (
        <div className="guide-content-inner">
          <p>Need to verify an account? You can purchase a temporary number for SMS verification:</p>
          <ol>
            <li>Navigate to the <strong>Virtual Numbers</strong> section from the sidebar.</li>
            <li>Select the country you need the number from.</li>
            <li>Choose the service (e.g., WhatsApp, Telegram, Google) you want to verify.</li>
            <li>Click on <strong>Buy Number</strong>. The cost will be deducted from your balance.</li>
            <li>The number will be displayed on your screen. Use this number on the service you are verifying.</li>
            <li>Wait for the SMS code to arrive. It will automatically appear on the screen. <em>Note: If the code does not arrive within the time limit, the cost is refunded to your balance.</em></li>
          </ol>
        </div>
      )
    },
    {
      title: 'How to Rent a Number',
      icon: <PhoneCall className="guide-icon" size={24} />,
      content: (
        <div className="guide-content-inner">
          <p>If you need a number for a longer period (e.g., a few hours to several weeks), you can rent one:</p>
          <ol>
            <li>Go to the <strong>Virtual Numbers</strong> section and click on the <strong>Rent Number</strong> tab.</li>
            <li>Select the desired country for the rented number.</li>
            <li>Choose the rental duration (e.g., 4 hours, 1 day, 1 week, 1 month).</li>
            <li>Click <strong>Rent</strong>. The total cost will be deducted from your balance.</li>
            <li>You can now receive unlimited SMS messages from any service to this number for the duration of the rental.</li>
            <li>View all incoming messages directly in the active rentals section.</li>
          </ol>
        </div>
      )
    }
  ];

  return (
    <div className="guide-container">
      <div className="guide-header">
        <h1>Platform Guide</h1>
        <p>Everything you need to know about using NiceBooster</p>
      </div>

      <div className="guide-accordion">
        {guides.map((guide, index) => (
          <div 
            key={index} 
            className={`guide-item ${activeTab === index ? 'active' : ''}`}
            onClick={() => toggleTab(index)}
          >
            <div className="guide-item-header">
              <div className="guide-item-title">
                <div className="icon-wrapper">
                  {guide.icon}
                </div>
                <h3>{guide.title}</h3>
              </div>
              <ChevronDown 
                className={`chevron-icon ${activeTab === index ? 'rotate' : ''}`} 
                size={20} 
              />
            </div>
            <div 
              className="guide-item-content-wrapper"
              style={{
                maxHeight: activeTab === index ? '1000px' : '0',
                opacity: activeTab === index ? '1' : '0'
              }}
            >
              <div className="guide-item-content">
                {guide.content}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
